import { render, staticRenderFns } from "./HoldBtn.vue?vue&type=template&id=50d1aab0&"
import script from "./HoldBtn.vue?vue&type=script&lang=js&"
export * from "./HoldBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports